const serializeForm = (form, opts = {}) => {
	return new Promise((resolve) => {
		//return new FormData(form);
		let defaultOpts = {
			ignoreEmpty: false,
		}

		opts = {...defaultOpts, ...opts};

		let formData = new FormData();

		let elements = (form.elements ? form.elements : form.querySelectorAll('input, textarea, select'));

		for (var i = 0; i < elements.length; i++) {

			var field = elements[i];

			if (!field.name /*|| field.disabled*/ || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

			if (field.type === 'select-multiple') {
				for (var n = 0; n < field.options.length; n++) {
					if (!field.options[n].selected) continue;
					let val = field.options[n].value;

					if (!(opts.ignoreEmpty && val === '')) {
						// let name = field.name.replace('[]', '');
						// if (serialized[name] && name + '[]' === field.name) {
						// 	val = serialized[name] += seperator + val;
						// }
						formData.append(field.name, val);
					}
				}
			}

			else if (field.type === 'file' && field.files.length) {

				for (var k = 0; k < field.files.length; k++) {
					formData.append(field.name + '[]', field.files[k]);
				}
			}

			else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
				let val = field.value;

				if (!(opts.ignoreEmpty && (val === '' || val === undefined || val === false))) {
					// let name = field.name.replace('[]', '');
					// if (serialized[name] && name + '[]' === field.name) {
					// 	val = serialized[name] += seperator + val;
					// }

					formData.append(field.name, val);
				}
			}
		}

		resolve(formData);
	});
}

export default serializeForm